import { render, staticRenderFns } from "./HeadView.vue?vue&type=template&id=24c2467a&scoped=true&"
import script from "./HeadView.vue?vue&type=script&lang=js&"
export * from "./HeadView.vue?vue&type=script&lang=js&"
import style0 from "./HeadView.vue?vue&type=style&index=0&id=24c2467a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2467a",
  null
  
)

export default component.exports